// Encouraia shared page scroll lock.
// Multiple overlays use this manager so mobile scrolling is always restored reliably.
window.EncouraiaScrollLock = window.EncouraiaScrollLock || (() => {
  const locks = new Set();
  const apply = () => {
    const locked = locks.size > 0;
    document.documentElement.classList.toggle('enc-scroll-locked', locked);
    document.body && document.body.classList.toggle('enc-scroll-locked', locked);
    if (!locked) {
      document.documentElement.style.removeProperty('overflow');
      if (document.body) document.body.style.removeProperty('overflow');
    }
  };
  return {
    lock(key = 'default') { locks.add(key); apply(); },
    unlock(key = 'default') { locks.delete(key); apply(); },
    reset() { locks.clear(); apply(); },
    isLocked() { return locks.size > 0; }
  };
})();

document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-menu]');
  if (trigger) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) {
      const willOpen = nav.hasAttribute('hidden');
      nav.toggleAttribute('hidden');
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      trigger.setAttribute('aria-label', willOpen ? 'Close menu' : 'Open menu');
    }
    return;
  }

  // Let native links navigate normally; close menu without intercepting the tap.
  const mobileNavLink = event.target.closest('[data-mobile-nav] a[href]');
  if (mobileNavLink) {
    const nav = mobileNavLink.closest('[data-mobile-nav]');
    const menuButton = document.querySelector('[data-mobile-menu]');
    if (nav) nav.setAttribute('hidden', '');
    if (menuButton) { menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label', 'Open menu'); }
    return;
  }

  const opener = event.target.closest('[data-look-inside-open]');
  if (opener) openLookInside(opener);

  if (event.target.closest('[data-look-inside-close]')) closeLookInside();
  if (event.target.closest('[data-look-inside-zoom-in]')) setLookInsideZoom(0.25);
  if (event.target.closest('[data-look-inside-zoom-out]')) setLookInsideZoom(-0.25);
  if (event.target.closest('[data-look-inside-reset]')) resetLookInsideZoom();
});

let lookInsideScale = 1;
let lookInsideBaseWidth = 0;

function getLookInsideElements() {
  const modal = document.querySelector('[data-look-inside-modal]');
  if (!modal) return {};
  return {
    modal,
    image: modal.querySelector('[data-look-inside-image]'),
    viewport: modal.querySelector('[data-look-inside-viewport]'),
    reset: modal.querySelector('[data-look-inside-reset]')
  };
}

function openLookInside(opener) {
  const { modal, image, viewport } = getLookInsideElements();
  if (!modal || !image) return;

  image.src = opener.dataset.imageSrc || '';
  image.alt = opener.dataset.imageAlt || '';
  lookInsideScale = 1;
  lookInsideBaseWidth = Math.min(window.innerWidth * 0.92, 850);
  image.style.width = `${lookInsideBaseWidth}px`;
  updateLookInsideResetLabel();
  if (viewport) viewport.scrollTo({ top: 0, left: 0 });

  if (typeof modal.showModal === 'function') modal.showModal();
  else modal.setAttribute('open', '');
  window.EncouraiaScrollLock.lock('look-inside');
}

function closeLookInside() {
  const { modal, image } = getLookInsideElements();
  if (!modal) return;
  if (typeof modal.close === 'function' && modal.open) modal.close();
  else modal.removeAttribute('open');
  if (image) image.src = '';
  window.EncouraiaScrollLock.unlock('look-inside');
}

function setLookInsideZoom(delta) {
  const { image } = getLookInsideElements();
  if (!image) return;
  lookInsideScale = Math.max(0.75, Math.min(3, lookInsideScale + delta));
  image.style.width = `${lookInsideBaseWidth * lookInsideScale}px`;
  updateLookInsideResetLabel();
}

function resetLookInsideZoom() {
  const { image, viewport } = getLookInsideElements();
  if (!image) return;
  lookInsideScale = 1;
  image.style.width = `${lookInsideBaseWidth}px`;
  updateLookInsideResetLabel();
  if (viewport) viewport.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

function updateLookInsideResetLabel() {
  const { reset } = getLookInsideElements();
  if (reset) reset.textContent = `${Math.round(lookInsideScale * 100)}%`;
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeLookInside();
  if (event.key === '+' || event.key === '=') setLookInsideZoom(0.25);
  if (event.key === '-') setLookInsideZoom(-0.25);
});

document.addEventListener('dblclick', (event) => {
  const image = event.target.closest('[data-look-inside-image]');
  if (!image) return;
  if (lookInsideScale > 1) resetLookInsideZoom();
  else setLookInsideZoom(0.75);
});

// Product experience v1.3
(function(){
  function money(cents){
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((cents||0)/100)}catch(e){return '$'+((cents||0)/100).toFixed(2)}
  }

  function initProductHero(hero){
    if(!hero) return;
    var variantJson=hero.querySelector('[data-product-variants]');
    var variants=[];
    try{variants=JSON.parse(variantJson&&variantJson.textContent||'[]')}catch(e){variants=[]}
    var form=hero.querySelector('.product-form-v2');
    if(!form) return;
    var idInput=form.querySelector('[data-variant-id]');
    var submit=form.querySelector('[data-product-submit]');
    var submitText=form.querySelector('[data-product-submit-text]');
    var price=hero.querySelector('[data-product-price]');
    var compare=hero.querySelector('[data-product-compare-price]');
    var savings=hero.querySelector('[data-product-savings]');
    var sectionId=hero.getAttribute('data-section-id');
    var stickyRoot=(sectionId && document.querySelector('[data-mobile-sticky][data-sticky-section-id="'+sectionId+'"]')) || hero.querySelector('[data-mobile-sticky]');
    var sticky=stickyRoot&&stickyRoot.querySelector('[data-sticky-add]');
    var stickyBuyNow=stickyRoot&&stickyRoot.querySelector('[data-sticky-buy-now]');
    var stickyText=stickyRoot&&stickyRoot.querySelector('[data-sticky-add-text]');
    var stickyPrice=stickyRoot&&stickyRoot.querySelector('[data-sticky-price]');
    var stickyCompare=stickyRoot&&stickyRoot.querySelector('[data-sticky-compare-price]');
    var stickySelect=stickyRoot&&stickyRoot.querySelector('[data-sticky-variant-select]');
    var stickyImage=stickyRoot&&stickyRoot.querySelector('[data-sticky-image]');
    var status=hero.querySelector('[data-product-status]');

    function selectedOptions(){
      return Array.from(hero.querySelectorAll('[data-product-option]')).map(function(fieldset){
        var checked=fieldset.querySelector('input[type="radio"]:checked');
        return checked?checked.value:null;
      });
    }

    function findVariant(){
      var selected=selectedOptions();
      if(!selected.length) return variants.find(function(v){return String(v.id)===String(idInput.value)})||variants[0];
      return variants.find(function(v){return selected.every(function(value,index){return v.options[index]===value})});
    }

    function renderVariant(variant){
      if(!variant) return;
      idInput.value=variant.id;
      if(price) price.textContent=money(variant.price);
      if(stickyPrice) stickyPrice.textContent=money(variant.price);
      if(stickyCompare){
        if(variant.compare_at_price && variant.compare_at_price>variant.price){stickyCompare.hidden=false;stickyCompare.textContent=money(variant.compare_at_price)}
        else{stickyCompare.hidden=true;stickyCompare.textContent=''}
      }
      if(stickySelect) stickySelect.value=String(variant.id);
      if(stickyImage && variant.featured_image && variant.featured_image.src){stickyImage.src=variant.featured_image.src;stickyImage.removeAttribute('srcset')}
      if(compare){
        if(variant.compare_at_price && variant.compare_at_price>variant.price){compare.hidden=false;compare.textContent=money(variant.compare_at_price)}
        else{compare.hidden=true;compare.textContent=''}
      }
      if(savings){
        if(variant.compare_at_price && variant.compare_at_price>variant.price){
          savings.hidden=false;
          savings.textContent='LIMITED-TIME OFFER · SAVE '+money(Number(variant.compare_at_price)-Number(variant.price)).replace(/\.00(?=\D*$)/,'');
        }else{
          savings.hidden=true;
          savings.textContent='';
        }
      }
      var available=!!variant.available;
      if(submit) submit.disabled=!available;
      if(sticky) sticky.disabled=!available;
      if(stickyBuyNow) stickyBuyNow.disabled=!available;
      if(submitText) submitText.textContent=available?(submitText.dataset.defaultLabel||'Add to cart'):'Sold out';
      if(stickyText) stickyText.textContent=available?(stickyText.dataset.defaultLabel||'Add to cart'):'Sold out';
      if(status){status.textContent='';status.classList.remove('is-error')}
      if(variant.featured_media && variant.featured_media.id){
        var thumb=hero.querySelector('[data-product-thumb][data-media-id="'+variant.featured_media.id+'"]');
        if(thumb){
          var track=hero.querySelector('[data-product-media-track]');
          var slide=hero.querySelector('[data-product-media-slide][data-media-id="'+variant.featured_media.id+'"]');
          if(track&&slide){try{track.scrollTo({left:slide.offsetLeft,behavior:'smooth'})}catch(e){track.scrollLeft=slide.offsetLeft;}}
          thumb.classList.add('is-active');
        }
      }
      try{history.replaceState({},'',window.location.pathname+'?variant='+variant.id)}catch(e){}
    }

    if(submitText) submitText.dataset.defaultLabel=submitText.textContent.trim()||'Add to cart';
    if(stickyText) stickyText.dataset.defaultLabel=stickyText.textContent.trim()||'Add to cart';

    hero.addEventListener('change',function(event){
      if(event.target.matches('[data-product-option] input[type="radio"]')) renderVariant(findVariant());
    });


    if(stickySelect){
      stickySelect.addEventListener('change',function(event){
        var picked=variants.find(function(v){return String(v.id)===String(event.target.value)});
        if(picked){
          hero.querySelectorAll('[data-product-option]').forEach(function(fieldset,index){
            var wanted=picked.options[index];
            var radio=Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(function(input){return input.value===wanted});
            if(radio) radio.checked=true;
          });
          renderVariant(picked);
        }
      });
    }

    form.addEventListener('submit',function(){
      if(submit && !submit.disabled){submit.classList.add('is-loading');if(status) status.textContent='Adding to cart…'}
    });

    renderVariant(findVariant());
  }

  document.querySelectorAll('[data-product-hero]').forEach(initProductHero);

  function getGallerySlides(hero){
    return hero ? Array.from(hero.querySelectorAll('[data-product-media-slide]')) : [];
  }

  function getGalleryThumbs(hero){
    return hero ? Array.from(hero.querySelectorAll('[data-product-thumb]')) : [];
  }

  function setGalleryActive(hero, mediaId, autoplayVideo){
    if(!hero || !mediaId) return;
    getGallerySlides(hero).forEach(function(slide){
      var active=String(slide.dataset.mediaId)===String(mediaId);
      slide.classList.toggle('is-active', active);

      slide.querySelectorAll('video').forEach(function(video){
        if(active && autoplayVideo){
          // Browsers allow reliable autoplay only when the video starts muted.
          video.muted=true;
          video.loop=true;
          video.setAttribute('playsinline','');
          try{
            var playPromise=video.play();
            if(playPromise && typeof playPromise.catch==='function') playPromise.catch(function(){});
          }catch(e){}
        }else if(!active){
          try{video.pause()}catch(e){}
        }
      });

      if(!active){
        slide.querySelectorAll('iframe').forEach(function(frame){
          // External embeds stay loaded; autoplay-on-active applies to Shopify-hosted video.
        });
      }
    });
    getGalleryThumbs(hero).forEach(function(thumb){
      var active=String(thumb.dataset.mediaId)===String(mediaId);
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active){
        try{thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}catch(e){}
      }
    });
  }

  function galleryIsMobile(){
    return window.matchMedia ? window.matchMedia('(max-width: 900px)').matches : window.innerWidth<=900;
  }


  function updateDesktopGalleryOrphan(hero){
    if(!hero) return;
    var slides=getGallerySlides(hero);
    slides.forEach(function(slide){
      slide.classList.remove('is-gallery-orphan');
      slide.classList.remove('is-gallery-pair-fill');
    });
    if(galleryIsMobile()) return;

    var gallery=hero.querySelector('.product-hero-v2__gallery');
    if(gallery && gallery.classList.contains('is-gallery-expanded')) return;

    var visible=slides.filter(function(slide){
      return window.getComputedStyle(slide).display !== 'none';
    });
    if(visible.length < 2) return;

    var supporting=visible.filter(function(slide, index){
      if(index === 0) return false; // lead image already spans both columns
      var isSecond = slide === visible[1];
      var type = slide.dataset.mediaType || '';
      if(isSecond && (type === 'video' || type === 'external_video')) return false;
      return true;
    });

    // If the visible supporting set is odd, reveal the next hidden media item
    // so the final row stays as two equal tiles rather than one stretched tile.
    if(supporting.length % 2 === 1){
      var nextHidden=slides.find(function(slide){
        return slide.hasAttribute('data-gallery-extra') && window.getComputedStyle(slide).display === 'none';
      });
      if(nextHidden) nextHidden.classList.add('is-gallery-pair-fill');
    }
  }

  function revealGalleryMediaIfNeeded(hero, slide){
    if(!hero || !slide || galleryIsMobile()) return;
    if(slide.hasAttribute('data-gallery-extra')){
      var gallery=hero.querySelector('.product-hero-v2__gallery');
      var more=hero.querySelector('[data-product-gallery-more]');
      if(gallery) gallery.classList.add('is-gallery-expanded');
      if(more){
        more.setAttribute('aria-expanded','true');
        more.textContent='Show fewer images';
      }
    }
  }

  function scrollToGalleryMedia(hero, mediaId, behavior, autoplayVideo){
    if(!hero || !mediaId) return;
    var track=hero.querySelector('[data-product-media-track]');
    var slide=hero.querySelector('[data-product-media-slide][data-media-id="'+mediaId+'"]');
    if(!track || !slide) return;

    revealGalleryMediaIfNeeded(hero,slide);

    if(galleryIsMobile()){
      var left=slide.offsetLeft;
      try{track.scrollTo({left:left,behavior:behavior||'smooth'})}catch(e){track.scrollLeft=left;}
    }
    setGalleryActive(hero,mediaId,!!autoplayVideo);
  }

  function stepGallery(hero, direction){
    if(!hero) return;
    var slides=getGallerySlides(hero);
    if(!slides.length) return;
    var current=slides.findIndex(function(el){return el.classList.contains('is-active')});
    if(current<0){
      var track=hero.querySelector('[data-product-media-track]');
      var width=track&&track.clientWidth||1;
      current=Math.round((track&&track.scrollLeft||0)/width);
    }
    var next=(current+direction+slides.length)%slides.length;
    scrollToGalleryMedia(hero,slides[next].dataset.mediaId,'smooth',false);
  }

  function initGalleryControls(hero){
    if(!hero || hero.dataset.galleryControlsInit==='true') return;
    hero.dataset.galleryControlsInit='true';
    var track=hero.querySelector('[data-product-media-track]');
    if(!track) return;

    updateDesktopGalleryOrphan(hero);
    window.addEventListener('resize',function(){ updateDesktopGalleryOrphan(hero); },{passive:true});

    // Thumbnail anchors are deliberately real anchors. If JavaScript ever fails,
    // the browser can still move to the requested slide natively.
    getGalleryThumbs(hero).forEach(function(thumb){
      thumb.addEventListener('click',function(event){
        var mediaId=thumb.dataset.mediaId;
        if(!mediaId) return;
        event.preventDefault();
        scrollToGalleryMedia(hero,mediaId,'smooth',false);
      });
    });

    var prev=hero.querySelector('[data-product-gallery-prev]');
    if(prev) prev.addEventListener('click',function(event){event.preventDefault();stepGallery(hero,-1)});
    var next=hero.querySelector('[data-product-gallery-next]');
    if(next) next.addEventListener('click',function(event){event.preventDefault();stepGallery(hero,1)});

    var more=hero.querySelector('[data-product-gallery-more]');
    if(more){
      more.addEventListener('click',function(){
        var gallery=hero.querySelector('.product-hero-v2__gallery');
        if(!gallery) return;
        var expanded=!gallery.classList.contains('is-gallery-expanded');
        gallery.classList.toggle('is-gallery-expanded',expanded);
        updateDesktopGalleryOrphan(hero);
        more.setAttribute('aria-expanded',expanded?'true':'false');
        more.textContent=expanded?'Show fewer images':'Show more images';
        if(!expanded){
          var activeSlide=hero.querySelector('[data-product-media-slide].is-active');
          if(activeSlide && activeSlide.hasAttribute('data-gallery-extra')){
            var first=getGallerySlides(hero)[0];
            if(first) setGalleryActive(hero,first.dataset.mediaId,false);
          }
        }
      });
    }

    // Mobile tap navigation: a quick tap on an image advances/reverses the gallery
    // while preserving native horizontal swiping and vertical page scrolling.
    // Left 30% = previous; right 70% = next. Interactive controls are excluded.
    var galleryPointerStart=null;
    track.addEventListener('pointerdown',function(event){
      if(!galleryIsMobile() || event.button>0) return;
      var slide=event.target.closest('[data-product-media-slide]');
      if(!slide || (slide.dataset.mediaType && slide.dataset.mediaType!=='image')) return;
      if(event.target.closest('button, a, input, select, textarea, video, iframe, model-viewer, [data-product-media-zoom]')) return;
      galleryPointerStart={
        pointerId:event.pointerId,
        x:event.clientX,
        y:event.clientY,
        time:Date.now(),
        slide:slide,
        moved:false
      };
    },{passive:true});

    track.addEventListener('pointermove',function(event){
      if(!galleryPointerStart || galleryPointerStart.pointerId!==event.pointerId) return;
      var dx=Math.abs(event.clientX-galleryPointerStart.x);
      var dy=Math.abs(event.clientY-galleryPointerStart.y);
      if(dx>10 || dy>10) galleryPointerStart.moved=true;
    },{passive:true});

    track.addEventListener('pointercancel',function(event){
      if(galleryPointerStart && galleryPointerStart.pointerId===event.pointerId) galleryPointerStart=null;
    },{passive:true});

    track.addEventListener('pointerup',function(event){
      if(!galleryPointerStart || galleryPointerStart.pointerId!==event.pointerId) return;
      var tap=galleryPointerStart;
      galleryPointerStart=null;
      if(!galleryIsMobile() || tap.moved || (Date.now()-tap.time)>600) return;
      if(event.target.closest('button, a, input, select, textarea, video, iframe, model-viewer, [data-product-media-zoom]')) return;

      var rect=tap.slide.getBoundingClientRect();
      if(!rect.width) return;
      var relativeX=(event.clientX-rect.left)/rect.width;
      stepGallery(hero,relativeX<0.30?-1:1);
    },{passive:true});

    var scrollTimer=null;
    track.addEventListener('scroll',function(){
      if(!galleryIsMobile()) return;
      if(scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer=window.setTimeout(function(){
        var slides=getGallerySlides(hero);
        if(!slides.length) return;
        var center=track.scrollLeft+(track.clientWidth/2);
        var nearest=slides[0],distance=Infinity;
        slides.forEach(function(slide){
          var slideCenter=slide.offsetLeft+(slide.offsetWidth/2);
          var d=Math.abs(slideCenter-center);
          if(d<distance){distance=d;nearest=slide;}
        });
        if(nearest) setGalleryActive(hero,nearest.dataset.mediaId,false);
      },60);
    },{passive:true});

    // Custom video poster: keep videos still until the shopper explicitly presses play.
    hero.querySelectorAll('[data-product-video-play]').forEach(function(button){
      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var poster=button.closest('[data-product-video-poster]');
        var slide=button.closest('[data-product-media-slide]');
        if(poster) poster.hidden=true;
        if(slide){
          var video=slide.querySelector('video');
          if(video){
            video.muted=false;
            video.loop=false;
            try{
              var playPromise=video.play();
              if(playPromise && typeof playPromise.catch==='function') playPromise.catch(function(){});
            }catch(e){}
          }
        }
      });
    });

    // Target-style zoom button on gallery images.
    var zoomModal=hero.querySelector('[data-product-zoom-modal]');
    var zoomImage=hero.querySelector('[data-product-zoom-image]');
    var zoomClose=hero.querySelector('[data-product-zoom-close]');
    var lastZoomTrigger=null;

    function closeZoom(){
      if(!zoomModal) return;
      zoomModal.hidden=true;
      zoomModal.setAttribute('aria-hidden','true');
      window.EncouraiaScrollLock.unlock('product-zoom');
      if(lastZoomTrigger && typeof lastZoomTrigger.focus==='function') lastZoomTrigger.focus();
    }

    hero.querySelectorAll('[data-product-media-zoom]').forEach(function(button){
      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        if(!zoomModal || !zoomImage) return;
        lastZoomTrigger=button;
        zoomImage.src=button.dataset.zoomSrc||'';
        zoomImage.alt=button.dataset.zoomAlt||'';
        zoomModal.hidden=false;
        zoomModal.setAttribute('aria-hidden','false');
        window.EncouraiaScrollLock.lock('product-zoom');
        if(zoomClose) zoomClose.focus();
      });
    });

    if(zoomClose) zoomClose.addEventListener('click',closeZoom);
    if(zoomModal){
      zoomModal.addEventListener('click',function(event){
        if(event.target===zoomModal) closeZoom();
      });
    }
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape' && zoomModal && !zoomModal.hidden) closeZoom();
    });

    var active=hero.querySelector('[data-product-media-slide].is-active') || getGallerySlides(hero)[0];
    if(active) window.requestAnimationFrame(function(){
      // Initial page load never auto-plays. Autoplay begins only after the shopper
      // navigates/swipes onto a video slide.
      scrollToGalleryMedia(hero,active.dataset.mediaId,'auto',false);
      window.setTimeout(function(){hero.dataset.galleryReady='true'},180);
    });
  }

  document.querySelectorAll('[data-product-hero]').forEach(initGalleryControls);

  document.addEventListener('shopify:section:load',function(event){
    var scope=event.target || document;
    scope.querySelectorAll && scope.querySelectorAll('[data-product-hero]').forEach(initGalleryControls);
  });

  /* Sticky ATC submission is owned by sections/main-product.liquid.
     Do not add a second delegated handler here: requestSubmit() would fire twice. */
})();

// Encouraia premium AJAX cart drawer
(function(){
  var drawer=document.querySelector('[data-enc-cart-drawer]');
  if(!drawer) return;
  var body=drawer.querySelector('[data-cart-drawer-body]');
  var footer=drawer.querySelector('[data-cart-drawer-footer]');
  var subtotal=drawer.querySelector('[data-cart-subtotal]');
  var savingsRow=drawer.querySelector('[data-cart-savings-row]');
  var savingsAmount=drawer.querySelector('[data-cart-savings]');
  var savingsLabel=drawer.querySelector('[data-cart-savings-label]');
  var savingsMessage=drawer.querySelector('[data-cart-savings-message]');
  var lastFocused=null;

  function money(cents){
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((cents||0)/100)}catch(e){return '$'+((cents||0)/100).toFixed(2)}
  }
  function esc(value){return String(value==null?'':value).replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}
  function friendlyDiscountTitle(title){
    title=decodeHtml(title||'');
    if(title.indexOf('Bundle - 2 Books')>-1) return '10% Bundle Savings Applied';
    if(title.indexOf('Bundle - 3 Books')>-1) return '15% Bundle Savings Applied';
    return title||'Savings applied';
  }
  function isBundleDiscountTitle(title){
    title=decodeHtml(title||'');
    return title.indexOf('Bundle - 2 Books')>-1||title.indexOf('Bundle - 3 Books')>-1;
  }
  function decodeHtml(value){
    var textarea=document.createElement('textarea');
    textarea.innerHTML=String(value==null?'':value);
    return textarea.value;
  }
  var crossSellCache={};
  function crossSellDataForItem(item){
    if(!item||!item.product_id||!item.url) return Promise.resolve(null);
    if(Object.prototype.hasOwnProperty.call(crossSellCache,item.product_id)) return Promise.resolve(crossSellCache[item.product_id]);
    var base=String(item.url).split('?')[0];
    return fetch(base,{headers:{Accept:'text/html'}}).then(function(r){if(!r.ok)throw new Error('Cross-sell lookup failed');return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var node=doc.querySelector('[data-enc-cart-cross-sell-json]');
      var data=null;
      if(node){try{data=JSON.parse(node.textContent)}catch(e){data=null}}
      if(!data||!data.available) data=null;
      crossSellCache[item.product_id]=data;
      return data;
    }).catch(function(){crossSellCache[item.product_id]=null;return null});
  }
  function crossSellHtml(rec){
    var variant=(rec.variant_title&&rec.variant_title!=='Default Title')?'<p class="enc-cart-cross-sell__variant">'+esc(decodeHtml(rec.variant_title))+'</p>':'';
    var image=rec.image?'<a class="enc-cart-cross-sell__image" href="'+esc(rec.url)+'"><img src="'+esc(rec.image)+'" alt="'+esc(decodeHtml(rec.title))+'" loading="lazy"></a>':'<div></div>';
    return '<div class="enc-cart-cross-sell"><p class="enc-cart-cross-sell__eyebrow">PAIR IT WITH</p><h3 class="enc-cart-cross-sell__heading">'+esc(decodeHtml(rec.heading||'A Meaningful Addition'))+'</h3><p class="enc-cart-cross-sell__text">'+esc(decodeHtml(rec.text||'Chosen to pair naturally with what is already in your cart.'))+'</p><div class="enc-cart-cross-sell__product">'+image+'<div><p class="enc-cart-cross-sell__title">'+esc(decodeHtml(rec.title))+'</p>'+variant+'<span class="enc-cart-cross-sell__price">'+money(rec.price)+'</span></div><button class="enc-cart-cross-sell__add" type="button" data-cart-cross-sell-add data-variant-id="'+esc(rec.variant_id)+'">+ Add</button></div></div>';
  }
  function renderCrossSell(cart){
    var slot=body.querySelector('[data-cart-cross-sell-slot]');
    if(!slot||!cart||!cart.items||!cart.items.length) return;
    var productIds={};cart.items.forEach(function(i){productIds[String(i.product_id)]=true});
    var items=cart.items.slice();
    function next(index){
      if(index>=items.length){slot.innerHTML='';return}
      crossSellDataForItem(items[index]).then(function(rec){
        if(rec&&rec.product_id&&!productIds[String(rec.product_id)]) slot.innerHTML=crossSellHtml(rec);
        else next(index+1);
      });
    }
    next(0);
  }
  function openDrawer(){
    lastFocused=document.activeElement;
    drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');window.EncouraiaScrollLock&&window.EncouraiaScrollLock.lock('cart-drawer');
    var close=drawer.querySelector('.enc-cart-drawer__close');if(close) close.focus();
  }
  function closeDrawer(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');window.EncouraiaScrollLock&&window.EncouraiaScrollLock.unlock('cart-drawer');if(lastFocused&&lastFocused.focus)lastFocused.focus()}
  function updateCounts(count){
    document.querySelectorAll('a[href="/cart"],a[href$="/cart"]').forEach(function(link){
      var visible=link.querySelector('[aria-hidden="true"]');if(visible&&visible.textContent.indexOf('(')>-1) visible.textContent='('+count+')';
      var badge=link.querySelector('.enc-mobile-nav__count');if(badge) badge.textContent=count;
      var hidden=link.querySelector('.visually-hidden');if(hidden) hidden.textContent='with '+count+' items';
    });
  }
  function itemHtml(item,index){
    var productTitle=decodeHtml(item.product_title);
    var variantTitle=decodeHtml(item.variant_title);
    var image=item.image?'<a class="enc-cart-item__image" href="'+esc(item.url)+'"><img src="'+esc(item.image)+'&width=300" alt="'+esc(productTitle)+'" loading="lazy"></a>':'<div></div>';
    var variant=(variantTitle&&variantTitle!=='Default Title')?'<p class="enc-cart-item__variant">'+esc(variantTitle)+'</p>':'';
    var discounted=(Number(item.original_line_price||0)>Number(item.final_line_price||0));
    var price=discounted?'<s>'+money(item.original_line_price)+'</s><strong>'+money(item.final_line_price)+'</strong><span class="enc-cart-item__saved">You save '+money(Number(item.original_line_price)-Number(item.final_line_price))+'</span>':'<strong>'+money(item.final_line_price)+'</strong>';
    var discountHtml='';
    if(item.discounts&&item.discounts.length){
      discountHtml='<div class="enc-cart-item__discounts">'+item.discounts.map(function(d){return '<span class="enc-cart-item__discount">✓ '+esc(friendlyDiscountTitle(d.title))+'</span>'}).join('')+'</div>';
    }
    return '<article class="enc-cart-item" data-cart-line="'+(index+1)+'">'+image+'<div class="enc-cart-item__info"><h3 class="enc-cart-item__title"><a href="'+esc(item.url)+'">'+esc(productTitle)+'</a></h3>'+variant+discountHtml+'<div class="enc-cart-item__price">'+price+'</div><div class="enc-cart-qty"><button type="button" data-cart-qty-minus aria-label="Decrease quantity">−</button><input type="number" min="0" value="'+item.quantity+'" data-cart-qty-input aria-label="Quantity for '+esc(productTitle)+'"><button type="button" data-cart-qty-plus aria-label="Increase quantity">+</button></div><button class="enc-cart-remove" type="button" data-cart-remove>Remove</button></div></article>';
  }
  function render(cart){
    updateCounts(cart.item_count||0);
    if(!cart.item_count){
      body.innerHTML='<div class="enc-cart-empty"><h3>Your cart is empty</h3><p>Add something meaningful when you’re ready.</p><a class="enc-cart-btn enc-cart-btn--view" href="/collections/all">Continue Shopping</a></div>';
      footer.hidden=true;return;
    }
    body.innerHTML=cart.items.map(itemHtml).join('')+'<div data-cart-cross-sell-slot></div>';
    subtotal.textContent=money(cart.total_price);
    var totalSavings=Math.max(0,Number(cart.original_total_price||0)-Number(cart.total_price||0));
    var hasBundleDiscount=(cart.items||[]).some(function(item){return (item.discounts||[]).some(function(d){return isBundleDiscountTitle(d.title)})});
    if(savingsRow&&savingsAmount){
      savingsRow.hidden=!totalSavings;
      savingsAmount.textContent=totalSavings?'−'+money(totalSavings):'';
    }
    if(savingsLabel) savingsLabel.textContent=hasBundleDiscount?'Bundle savings:':'Savings:';
    if(savingsMessage){
      savingsMessage.hidden=!totalSavings;
      savingsMessage.textContent=hasBundleDiscount?'✓ Your bundle savings have been applied automatically.':'✓ Your savings have been applied.';
    }
    footer.hidden=false;
    renderCrossSell(cart);
  }
  function getCart(open){
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('Cart could not be loaded');return r.json()}).then(function(cart){render(cart);if(open)openDrawer();return cart}).catch(function(){body.innerHTML='<div class="enc-cart-empty"><p>We couldn’t refresh your cart. Please try again.</p></div>'})
  }
  function change(line,quantity){
    body.style.opacity='.55';
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:quantity})}).then(function(r){if(!r.ok)throw new Error('Cart update failed');return r.json()}).then(render).finally(function(){body.style.opacity=''})
  }

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-close]')){e.preventDefault();closeDrawer();return}
    var cartLink=e.target.closest('a[href="/cart"],a[href$="/cart"]');
    if(cartLink&&!cartLink.closest('.enc-cart-drawer')){e.preventDefault();getCart(true);return}
    var crossAdd=e.target.closest('[data-cart-cross-sell-add]');
    if(crossAdd){
      e.preventDefault();
      var crossVariant=Number(crossAdd.dataset.variantId||0);
      if(!crossVariant)return;
      crossAdd.disabled=true;crossAdd.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:crossVariant,quantity:1}]})})
        .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||'Unable to add item')});return r.json()})
        .then(function(){return getCart(false)})
        .catch(function(){crossAdd.disabled=false;crossAdd.textContent='+ Add'});
      return;
    }
    var item=e.target.closest('[data-cart-line]');if(!item)return;
    var line=Number(item.dataset.cartLine),input=item.querySelector('[data-cart-qty-input]'),qty=Number(input&&input.value||0);
    if(e.target.closest('[data-cart-qty-minus]')){e.preventDefault();change(line,Math.max(0,qty-1))}
    if(e.target.closest('[data-cart-qty-plus]')){e.preventDefault();change(line,qty+1)}
    if(e.target.closest('[data-cart-remove]')){e.preventDefault();change(line,0)}
  });
  document.addEventListener('change',function(e){if(e.target.matches('[data-cart-qty-input]')){var item=e.target.closest('[data-cart-line]');change(Number(item.dataset.cartLine),Math.max(0,Number(e.target.value||0)))}});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))closeDrawer()});

  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    var submit=form.querySelector('[type="submit"]');if(submit)submit.disabled=true;
    var status=form.closest('[data-product-hero]')&&form.closest('[data-product-hero]').querySelector('[data-product-status]');
    if(status){status.textContent='Adding to cart…';status.classList.remove('is-error')}

    var storyTier=Number(form.dataset.encStoryTier||1);
    var storyVariants=(form.dataset.encStoryVariants||'').split(',').filter(Boolean);
    var mainVariant=form.querySelector('[data-variant-id]');
    var useStoryBundle=storyTier>1&&storyVariants.length===storyTier-1&&mainVariant&&mainVariant.value;
    var requestOptions;

    if(storyTier>1&&!useStoryBundle){
      if(status)status.textContent='Choose your additional journal'+(storyTier>2?'s':'')+' first.';
      if(submit)submit.disabled=false;
      return;
    }

    if(useStoryBundle){
      var items=[{id:Number(mainVariant.value),quantity:1}];
      storyVariants.forEach(function(id){items.push({id:Number(id),quantity:1})});
      requestOptions={method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})};
    }else{
      requestOptions={method:'POST',headers:{Accept:'application/json'},body:new FormData(form)};
    }

    fetch('/cart/add.js',requestOptions).then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||'Unable to add item')});return r.json()}).then(function(){if(status)status.textContent=useStoryBundle?'Your journals were added to cart.':'Added to cart';return getCart(true)}).catch(function(err){if(status){status.textContent=err.message;status.classList.add('is-error')}}).finally(function(){if(submit)submit.disabled=false});
  },true);

  window.EncouraiaCart={refresh:getCart,open:openDrawer,close:closeDrawer};
  document.addEventListener('encouraia:cart-refresh',function(e){getCart(!e.detail||e.detail.open!==false)});
  getCart(false);
})();


// Encouraia FBT controller
(function(){
  function money(cents){
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((cents||0)/100)}catch(e){return '$'+((cents||0)/100).toFixed(2)}
  }
  function selectedPrice(control){
    if(!control)return 0;
    if(control.tagName==='SELECT'){
      var option=control.options[control.selectedIndex];return Number(option&&option.dataset.price||0);
    }
    return Number(control.dataset.price||0);
  }
  function update(section){
    var cards=Array.prototype.slice.call(section.querySelectorAll('[data-enc-fbt-card]'));
    var count=0,total=0;
    cards.forEach(function(card){
      var check=card.querySelector('[data-enc-fbt-check]');
      var variant=card.querySelector('[data-enc-fbt-variant]');
      var on=!!(check&&check.checked);
      card.classList.toggle('is-unselected',!on);
      if(on){count++;total+=selectedPrice(variant)}
      var price=card.querySelector('[data-enc-fbt-price]');if(price)price.textContent=money(selectedPrice(variant));
    });
    var countEl=section.querySelector('[data-enc-fbt-count]');if(countEl)countEl.textContent=count+' selected';
    var totalEl=section.querySelector('[data-enc-fbt-total]');if(totalEl)totalEl.textContent=count?money(total):'';
    var button=section.querySelector('[data-enc-fbt-add]');if(button)button.disabled=count===0;
  }
  document.addEventListener('change',function(e){
    var section=e.target.closest('[data-enc-fbt]');
    if(section&&(e.target.matches('[data-enc-fbt-check]')||e.target.matches('[data-enc-fbt-variant]')))update(section);
  });
  document.addEventListener('click',function(e){
    var button=e.target.closest('[data-enc-fbt-add]');if(!button)return;
    var section=button.closest('[data-enc-fbt]');if(!section)return;
    e.preventDefault();
    var items=[];
    section.querySelectorAll('[data-enc-fbt-card]').forEach(function(card){
      var check=card.querySelector('[data-enc-fbt-check]');
      var variant=card.querySelector('[data-enc-fbt-variant]');
      if(check&&check.checked&&variant&&variant.value)items.push({id:Number(variant.value),quantity:1});
    });
    if(!items.length)return;
    var status=section.querySelector('[data-enc-fbt-status]');
    var label=button.querySelector('[data-enc-fbt-button-text]');
    var original=label?label.textContent:'Add Selected to Cart';
    button.disabled=true;if(label)label.textContent='Adding…';if(status){status.textContent='';status.classList.remove('is-error')}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||'Unable to add selected items')});return r.json()})
      .then(function(){if(status)status.textContent=items.length===1?'Added to your cart.':'Selected books added to your cart.';if(window.EncouraiaCart)return window.EncouraiaCart.refresh(true);document.dispatchEvent(new CustomEvent('encouraia:fbt-added',{detail:{items:items}}))})
      .catch(function(err){if(status){status.textContent=err.message||'Unable to add selected items.';status.classList.add('is-error')}})
      .finally(function(){button.disabled=false;if(label)label.textContent=original;update(section)});
  });
  document.querySelectorAll('[data-enc-fbt]').forEach(update);
})();

/* ==========================================================
   Encouraia iOS visual viewport anchor
   ========================================================== */
(function () {
  var raf = 0;

  function updateEncouraiaVisualViewport() {
    raf = 0;

    if (window.matchMedia && !window.matchMedia('(max-width: 900px)').matches) {
      document.documentElement.style.setProperty('--enc-vv-bottom', '0px');
      return;
    }

    var vv = window.visualViewport;
    var bottomGap = 0;

    if (vv) {
      bottomGap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    }

    document.documentElement.style.setProperty('--enc-vv-bottom', '0px');

    var nav = document.querySelector('.enc-mobile-nav');
    if (nav) {
      var navHeight = nav.getBoundingClientRect().height || 70;
      var safeInset = 0;
      /* navHeight already includes the CSS safe-area padding; sticky uses the
         visual nav height directly so the two controls remain flush. */
      document.documentElement.style.setProperty('--enc-mobile-nav-height', navHeight.toFixed(2) + 'px');
    }
  }

  function scheduleEncouraiaVisualViewportUpdate() {
    if (raf) return;
    raf = window.requestAnimationFrame(updateEncouraiaVisualViewport);
  }

  function initEncouraiaVisualViewportAnchor() {
    updateEncouraiaVisualViewport();

    window.addEventListener('resize', scheduleEncouraiaVisualViewportUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleEncouraiaVisualViewportUpdate, { passive: true });
    window.addEventListener('scroll', scheduleEncouraiaVisualViewportUpdate, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleEncouraiaVisualViewportUpdate, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleEncouraiaVisualViewportUpdate, { passive: true });
    }

    document.addEventListener('shopify:section:load', scheduleEncouraiaVisualViewportUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEncouraiaVisualViewportAnchor, { once: true });
  } else {
    initEncouraiaVisualViewportAnchor();
  }
})();

// Encouraia cart-page cross-sell add buttons
(function(){
  document.addEventListener('click',function(event){
    var btn=event.target.closest('[data-enc-page-upsell-add]');
    if(!btn||btn.disabled) return;
    var id=Number(btn.getAttribute('data-variant-id'));
    if(!id) return;
    var old=btn.textContent;
    btn.disabled=true;
    btn.textContent='Adding…';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})
    }).then(function(r){if(!r.ok) throw new Error('Add failed');return r.json()})
      .then(function(){btn.textContent='Added ✓';window.setTimeout(function(){window.location.reload()},350)})
      .catch(function(){btn.disabled=false;btn.textContent=old})
  });
})();

/* Encouraia — keep the Free Coloring Pages edge tab from covering mobile PDP content. */
(function () {
  var observer = null;
  var scheduled = false;

  function adjustFreeColoringTab() {
    scheduled = false;
    var onProduct = document.body && document.body.classList.contains('template-product');
    var narrow = window.matchMedia('(max-width: 749px)').matches;

    /* This workaround is only needed on product pages. Avoid scanning the entire DOM
       after every app mutation; limit candidates to elements likely to contain the tab. */
    var nodes = document.querySelectorAll('a, button, [role=\"button\"], div, span');
    var found = false;
    nodes.forEach(function (node) {
      if (node.children.length > 3) return;
      var label = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'free coloring pages') return;

      var target = node;
      for (var i = 0; i < 5 && target.parentElement; i++) {
        var style = window.getComputedStyle(target);
        if (style.position === 'fixed') break;
        target = target.parentElement;
      }
      if (window.getComputedStyle(target).position !== 'fixed') return;
      found = true;

      if (!target.dataset.encOriginalDisplay) {
        target.dataset.encOriginalDisplay = target.style.display || '__empty__';
      }
      if (narrow && onProduct) {
        target.style.setProperty('display', 'none', 'important');
      } else {
        var original = target.dataset.encOriginalDisplay;
        if (original === '__empty__') target.style.removeProperty('display');
        else target.style.display = original;
      }
    });

    /* Once the asynchronously injected tab has been found, continuous DOM observation
       is unnecessary and can create mobile main-thread work on app-heavy pages. */
    if (found && observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function scheduleAdjust() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(adjustFreeColoringTab);
  }

  document.addEventListener('DOMContentLoaded', scheduleAdjust);
  window.addEventListener('load', scheduleAdjust);
  window.addEventListener('resize', scheduleAdjust, { passive: true });

  if (document.body && document.body.classList.contains('template-product')) {
    observer = new MutationObserver(scheduleAdjust);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();


window.addEventListener('pageshow', function(){ if(window.EncouraiaScrollLock) window.EncouraiaScrollLock.unlock('cart-drawer'); });
